import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import SingleOffer from '../views/singleJobOffer';
import Layout from '../components/layout';
import { NavBar, PopupRedirect } from 'components';
import { pages } from '../config/pages';

const JobOfferPage = ({ data }) => {
  const { markdownRemark: offerData, allMarkdownRemark } = data;
  const page = pages.career;
  const { navColors } = page;

  const jobOfferList = allMarkdownRemark.edges.filter(
    edge => edge.node.frontmatter.templateKey === 'job-offer-page',
  );

  return (
    <Layout page={page}>
      <NavBar color={navColors} />
      <PopupRedirect message={'job-offer'} />
      <SingleOffer offer={offerData} />
    </Layout>
  );
};

JobOfferPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }).isRequired,
};

export default JobOfferPage;

export const pageQuery = graphql`
  query JobOfferByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      fields {
        slug
      }
      frontmatter {
        title
        lead
        settings {
          date
          metaDescription
          metaTitle
          slug
          canonical
          category
          cover
        }
        mainContent {
          name
          city
          salary
          salary2ndLine
          apply
          banner
          technical {
            skill
          }
          additional {
            skill
          }
          specifics {
            specific
          }
          photo
          steps {
            number
            step
            details
          }
        }
      }
    }
    allMarkdownRemark(sort: { order: ASC, fields: [frontmatter___title] }) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
          }
          frontmatter {
            title
            lead
            settings {
              date
              metaDescription
              metaTitle
              slug
              canonical
              category
              cover
            }
            mainContent {
              name
              city
              salary
              salary2ndLine
              apply
              banner
              technical {
                skill
              }
              additional {
                skill
              }
              specifics {
                specific
              }
              photo
              steps {
                number
                step
                details
              }
            }
          }
        }
      }
    }
  }
`;
